// NPM MODULES
import React from 'react';

// FORMATTED MESSAGES
import RootComponentsFormattedMessages from '../../messages/RootComponentsFormattedMessages';
import { Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

export default function BackButton({ onClick, hideDisplay, backButtonText }) {
  if (hideDisplay) return null;

  return (
    <Button
      onClick={() => onClick()}
      startIcon={<ArrowBack />}
      color="secondary"
    >
      {backButtonText ? backButtonText : RootComponentsFormattedMessages.back}
    </Button>
  );
}
